import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  analyticsAgeToBarChart,
  analyticsToPieChart,
  analyticsToListChart,
  analyticsHouseholdIncomeToBarChart,
  analyticsLocationToBarChart,
} from '../../to-chart';

import BarChart from '../../../../../../core/components/charts/bar-chart';
import CardAnalytics from '../../../../../../core/analytics/card-analytics';
import ListChart from '../../../../../../core/components/charts/list-chart';
import PieChart from '../../../../../../core/components/charts/pie-chart';

import {
  Container,
  Column,
  CardRow,
  Grid,
} from './styles';
import { getDemographicsByProjectId } from '../../graphql';

const UnmoderatedDemographics = (props) => {
  const {
    projectId,
    segmentId,
    isDemoProject,
  } = props;

  const [analyticsAge, setAnalyticsAge] = useState({});
  const [analyticsEthnicity, setAnalyticsEthnicity] = useState([]);
  const [analyticsGender, setAnalyticsGender] = useState({});
  const [analyticsHouseholdIncome, setAnalyticsHouseholdIncome] = useState({});
  const [analyticsLocation, setAnalyticsLocation] = useState({});

  useEffect(() => {
    async function fetchData() {
      let demographics = [];
      if (isDemoProject) {
        const { analyticsData } = await import('../../../../../demo-project');
        demographics = analyticsData;
      } else {
        const segmentSelected = segmentId !== 'all' ? segmentId : undefined;
        demographics = await getDemographicsByProjectId(projectId, segmentSelected);
      }

      setAnalyticsAge(analyticsAgeToBarChart(demographics.ageRange, 'rgba(0, 183, 242, 0.64)'));
      setAnalyticsEthnicity(analyticsToListChart(demographics.raceEthnicHeritage));
      setAnalyticsGender(analyticsToPieChart(demographics.gender));
      setAnalyticsHouseholdIncome(analyticsHouseholdIncomeToBarChart(demographics.annualHouseholdIncome, 'rgba(132, 164, 246, 0.71)'));
      setAnalyticsLocation(analyticsLocationToBarChart(demographics.country, 'rgba(28, 69, 135, 0.78)'));
    }
    fetchData();
    // do not add project in the dependecy, it will duplicate requests when clicking on charts
  }, [segmentId]);

  return (
    <Container>
      <Grid columns="equal">
        <CardRow>
          <Column>
            <CardAnalytics title="Age">
              <BarChart type="vertical" data={analyticsAge} />
            </CardAnalytics>
          </Column>
          <Column>
            <CardAnalytics title="Gender">
              <PieChart data={analyticsGender} />
            </CardAnalytics>
          </Column>
          <Column>
            <CardAnalytics title="Ethnicity">
              <ListChart data={analyticsEthnicity} color="#A7BEF9" />
            </CardAnalytics>
          </Column>
        </CardRow>
        <CardRow>
          <Column>
            <CardAnalytics title="Household Income">
              <BarChart type="vertical" data={analyticsHouseholdIncome} />
            </CardAnalytics>
          </Column>
          <Column>
            <CardAnalytics title="Location">
              <BarChart type="horizontal" data={analyticsLocation} />
            </CardAnalytics>
          </Column>
        </CardRow>
      </Grid>
    </Container>
  );
};

UnmoderatedDemographics.propTypes = {
  projectId: PropTypes.string.isRequired,
  segmentId: PropTypes.string.isRequired,
  isDemoProject: PropTypes.bool.isRequired,
};

export default UnmoderatedDemographics;
